(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();

      if (document.readyState !== 'complete') {
        window.addEventListener('load', () => this.setHeaderHeight());
      }
      if (document.fonts) {
        document.fonts.ready.then(() => this.setHeaderHeight());
      }

      window.matchMedia('(max-width: 1100px)').addEventListener('change', () => {
        this.setHeaderHeight();
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      const hamburgerBtn = this.querySelector('#MobileHamburger');
      const drawerCloseBtn = this.querySelector('#DrawerClose');
      const mobileDrawer = this.querySelector('#LuxuryMobileDrawer');

      if (hamburgerBtn && mobileDrawer) {
        hamburgerBtn.addEventListener('click', () => {
          mobileDrawer.classList.add('is-open');
        });
      }

      if (drawerCloseBtn && mobileDrawer) {
        drawerCloseBtn.addEventListener('click', () => {
          mobileDrawer.classList.remove('is-open');
        });
      }

      document.addEventListener('click', (e) => {
        if (mobileDrawer && mobileDrawer.classList.contains('is-open')) {
          if (!mobileDrawer.contains(e.target) && !hamburgerBtn.contains(e.target)) {
            mobileDrawer.classList.remove('is-open');
          }
        }
      });
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 40) {
        if (!this.header.classList.contains('scrolled-past-header')) {
          requestAnimationFrame(() => {
            this.header.classList.add('shopify-section-header-sticky', 'scrolled-past-header');
          });
        }
      } else {
        if (this.header.classList.contains('scrolled-past-header')) {
          requestAnimationFrame(() => {
            this.header.classList.remove('shopify-section-header-sticky', 'scrolled-past-header');
          });
        }
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
